import { gql } from '@apollo/client';

export const TOKEN_USD_VALUE_QUERY = gql`
  query tokenUsdValue($token: String!, $amount: String!) {
    tokenUsdValue(token: $token, amount: $amount)
  }
`;
